import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useParallax } from '../../hooks/useParallax';
import { Reveal } from '../ui-custom/Reveal';
import { useLanguage } from '../../contexts/LanguageContext';
import { theme } from '../../utils/theme';

export const Hero = ({ systemActive }) => {
  const parallax = useParallax(40);
  const navigate = useNavigate();
  const { t } = useLanguage();

  const scrollToDemo = () => {
    const demoSection = document.getElementById('filter-demo');
    if (demoSection) {
      demoSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative z-10 pt-32 pb-20 lg:pt-48 lg:pb-32 overflow-hidden min-h-screen flex flex-col justify-center">
      <div className="max-w-7xl mx-auto px-4 relative">
        
        <Reveal>
          <div className="flex justify-center mb-8">
            <div 
              className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border backdrop-blur-md shadow-[0_0_20px_rgba(0,0,0,0.5)] transform hover:scale-105 transition-transform cursor-default"
              style={{ backgroundColor: theme.colors.surface, borderColor: theme.colors.border }}
            >
              <span className={`w-2 h-2 rounded-full ${systemActive ? 'animate-pulse bg-green-500' : 'bg-gray-500'}`} />
              <span 
                className="text-s font-semibold tracking-wide uppercase" 
                style={{ color: theme.colors.secondary }}
              >
                {systemActive ? t.hero.systemActive : t.hero.systemSleep}
              </span>
            </div>
          </div>
        </Reveal>

        <Reveal delay={200}>
          <h1
            className="text-5xl md:text-8xl font-bold tracking-tight mb-6 leading-[1.1] select-none text-center bg-clip-text text-transparent bg-gradient-to-b from-white to-gray-300"
            style={{ transform: `translate(${parallax.x}px, ${parallax.y}px)` }}>

            {t.hero.title1}{' '}
            <span className="bg-gradient-to-r from-orange-300 to-orange-300 text-transparent bg-clip-text"
              style={{ color: theme.colors.primary}}>
              {t.hero.light}
            </span>
            .<br />
            {t.hero.title2}{' '}
            <span className="text-blue-400"
              style={{ color: theme.colors.secondary}}>
              {t.hero.energy}
            </span>
            .
          </h1>
        </Reveal>

        <Reveal delay={400}>
          <p
            className="mt-6 max-w-4xl mx-auto text-2xl font-light mb-12 opacity-80 text-center"
            style={{ color: theme.colors.textMuted }}>

            {t.hero.description}
          </p>
        </Reveal>

        <Reveal delay={600}>
          <div className="flex flex-col sm:flex-row justify-center gap-4 mb-20">
            <button
              onClick={() => navigate('/shop')}
              data-testid="buy-filter-btn"
              className="relative px-8 py-4 rounded-full font-bold text-xl transition-all hover:scale-105 overflow-hidden group"
              style={{
                background: theme.gradients.primary,
                color: '#000',
                boxShadow: `0 0 40px -10px ${theme.colors.primary}60`
              }}>

              <span className="relative z-10">{t.hero.buyButton}</span>
              <div className="absolute top-0 left-0 w-full h-full bg-white opacity-20 transform -translate-x-full group-hover:animate-[shimmer_1.5s_infinite]" />
            </button>
            <button
              onClick={scrollToDemo}
              data-testid="see-demo-btn"
              className="px-8 py-4 rounded-full font-bold text-xl border transition-all hover:bg-white/5 hover:border-white/40"
              style={{ borderColor: theme.colors.border, color: theme.colors.text }}>

              {t.hero.demoButton}
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
};